import { t } from "@lingui/macro";
import * as React from "react";
import { ClipPath, Defs, G, Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ClockAddIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="currentColor"
    title={t`Clock Add`}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="currentColor"
        d="M8 .25A7.75 7.75 0 0 1 15.75 8a.75.75 0 0 1-1.5 0A6.25 6.25 0 1 0 8 14.25a.75.75 0 0 1 0 1.5A7.75 7.75 0 0 1 8 .25Zm4.5 9a.75.75 0 0 1 .75.75v1.75H15a.75.75 0 0 1 0 1.5h-1.75V15a.75.75 0 0 1-1.5 0v-1.75H10a.75.75 0 0 1 0-1.5h1.75V10a.75.75 0 0 1 .75-.75ZM8 3.75a.75.75 0 0 1 .75.75v3.19l.78.78a.75.75 0 1 1-1.06 1.06l-1-1A.75.75 0 0 1 7.25 8V4.5A.75.75 0 0 1 8 3.75Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
